import type { ReactNode } from "react";

export type IconTileVariant = "neutral" | "emphasis" | "brand" | "info" | "success" | "warning" | "danger";
export type IconTileSize = "sm" | "md" | "lg";

const VARIANT_CLASSES: Record<IconTileVariant, string> = {
  neutral: "border border-border-subtle bg-surface-base text-content-tertiary",
  emphasis: "bg-surface-secondary text-content-primary",
  brand: "bg-brand-primary-subtle text-brand-primary-on-subtle",
  info: "bg-info-subtle text-info-on-subtle",
  success: "bg-success-subtle text-success-on-subtle",
  warning: "bg-warning-subtle text-warning-on-subtle",
  danger: "bg-error-subtle text-error-on-subtle",
};

/** `lg` matches SpaceIcon's own `lg` (size-10), for a page header's icon well next to a SpaceIcon-sized identity. */
const SIZE_CLASSES: Record<IconTileSize, string> = {
  sm: "size-6",
  md: "size-8",
  lg: "size-10",
};

export interface IconTileProps {
  children: ReactNode;

  variant?: IconTileVariant;
  size?: IconTileSize;
}

export function IconTile({ children, variant = "neutral", size = "md" }: Readonly<IconTileProps>) {
  return (
    <span className={`grid shrink-0 place-items-center rounded-lg ${SIZE_CLASSES[size]} ${VARIANT_CLASSES[variant]}`}>
      {children}
    </span>
  );
}
